import { render, staticRenderFns } from "./UserStats.vue?vue&type=template&id=aa667d58&scoped=true"
import script from "./UserStats.vue?vue&type=script&lang=js"
export * from "./UserStats.vue?vue&type=script&lang=js"
import style0 from "./UserStats.vue?vue&type=style&index=0&id=aa667d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa667d58",
  null
  
)

export default component.exports